import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm, Field } from 'redux-form';

import { TextField, RadioButtonGroup, Toggle } from 'redux-form-material-ui';
import { RadioButton } from 'material-ui/RadioButton';
import { CardText } from 'material-ui/Card';
import Card from '@material-ui/core/Card';

import MultiSelectExtended from 'components/shared/MultiSelectExtended';
import { required } from 'helpers/Validator';

import Header from 'components/shared/Header';
import { RenderError } from 'components/shared/RenderError';
import { getTranslatedString } from 'helpers/i18n';
import { featureEnabled } from 'helpers/ToggleBot';

const style = {
  transactionCard: {
    color: '#424242 !important',
    fontFamily: '"Questrial", sans-serif !important',
    height: '100%',
    overflow: 'hidden',
    borderRadius: '8px',
    marginBottom: '25px',
  },
};

class DetailsForm extends React.Component {
  render() {
    return (
      <Card style={style.transactionCard}>
        <CardText expandable style={{ padding: '0 0 10px' }}>
          {this.renderDetailsSection()}
          {this.renderTypeSection()}
        </CardText>
      </Card>
    );
  }

  renderDetailsSection = () => (
    <div className="row">
      <Header name="TEMPLATE DETAILS" />
      <div className="row" style={{ margin: '20px 0 20px' }}>
        <div className="col-xs-12">
          <h5 style={{ margin: '0' }}> Template Name </h5>
          <Field
            name="name"
            component={TextField}
            hintText="Name"
            style={{ fontSize: '15px' }}
            validate={required}
          />
        </div>
      </div>
      <div className="row" style={{ margin: '20px 0 20px' }}>
        <div className="col-xs-12">
          <h5 style={{ margin: '0' }}> Description </h5>
          <Field
            name="description"
            component={TextField}
            rows={2}
            multiLine
            hintText="Description"
            style={{ fontSize: '15px', width: '100%' }}
            validate={required}
          />
        </div>
      </div>
    </div>
  );

  renderTypeSection = () => (
    <div className="row">
      <Header name="TEMPLATE TYPE" />
      <div className="row" style={{ margin: '20px 0 20px' }}>
        <div className="col-xs-12">
          <h5 style={{ margin: '0' }}> Template Usage </h5>
          <Field
            name="inspection_type"
            component={RadioButtonGroup}
            style={{ margin: 'auto', marginTop: '10px' }}
          >
            <RadioButton
              value="property"
              label="Properties"
              style={{ width: '150px', display: 'inline-flex' }}
            />
            <RadioButton
              value="unit"
              label="Units"
              style={{ width: '150px', display: 'inline-flex' }}
            />
            <RadioButton
              value="turnover"
              label="Turnover"
              style={{ width: '150px', display: 'inline-flex' }}
            />
          </Field>
          <Field component={RenderError} name="inspection_type" validate={required} />
        </div>
      </div>
      {this.renderPropertySelector()}
      {this.renderUnitTypeSelector()}
      {this.renderResidentPerformInspection()}
    </div>
  );

  renderPropertySelector = () => {
    const { inspectionType, properties } = this.props;
    if (inspectionType !== 'property') return;

    return (
      <div className="row" style={{ margin: '20px 0 20px' }}>
        <div className="col-xs-12">
          <Field
            name="properties"
            component={MultiSelectExtended}
            multiple
            hintText="Applicable Properties"
            data={properties}
            style={{ fontSize: '14px', marginTop: '5px' }}
            fullWidth
            validate={required}
          />
        </div>
      </div>
    );
  };

  renderUnitTypeSelector = () => {
    const { inspectionType, unitTypes } = this.props;
    if (!['unit', 'turnover'].includes(inspectionType)) return;

    return (
      <div className="row" style={{ margin: '20px 0 20px' }}>
        <div className="col-xs-12">
          <Field
            name="unit_type_ids"
            component={MultiSelectExtended}
            multiple
            data={unitTypes}
            validate={[required]}
            hintText={getTranslatedString('unitType')}
            style={{ fontSize: '14px', marginTop: '5px' }}
            fullWidth
            withResetSelectAllButtons
          />
        </div>
      </div>
    );
  };

  renderResidentPerformInspection = () => {
    const { inspectionType, selfGuided } = this.props;
    if (!['turnover'].includes(inspectionType)) return;
    if (!featureEnabled('self-guided-inspections')) return;

    return (
      <div className="row" style={{ margin: '20px 0 20px' }}>
        <div className="col-xs-12">
          <Field
            name="self_guided"
            type="toggle"
            component={Toggle}
            label="Residents perform the inspection"
          />
        </div>

        {selfGuided && (
          <div className="col-xs-12">
            <Field
              name="self_guided_type"
              component={RadioButtonGroup}
              style={{ margin: 'auto', marginTop: '10px' }}
            >
              <RadioButton
                value="single_lease"
                label="Individual lease inspection"
                style={{ display: 'inline-flex' }}
              />
              <RadioButton
                value="group_lease"
                label="Group lease inspection"
                style={{ display: 'inline-flex' }}
              />
            </Field>
            <Field component={RenderError} name="inspection_type" validate={required} />
          </div>
        )}
      </div>
    );
  };
}

export default compose(
  connect((state) => {
    return {
      unitTypes: state.companyDetails.companyPreferences.unit_types || [],
    };
  }),
  reduxForm({ destroyOnUnmount: false })
)(DetailsForm);
